import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseExamination } from '@se/models';
import { GridUtilitiesService } from '@se/platform';
import { ServerRootService } from '@se/se.ui.html5';
import { ColDef } from 'ag-grid-community';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RemoveExamService extends ServerRootService {
    constructor(private httpClient: HttpClient, private translate: TranslateService, private gridUtils: GridUtilitiesService) {
        super();
    }

    removeExam(idReport: string, idExaminations: string[]) {
        return this.httpClient.post(this.getServerRoot() + '/Visit/RemoveExaminationsToReport', { idReport, idExaminations }, this.buildOptions());
    }

    search(idReport: string): Observable<BaseExamination[]> {
        return this.httpClient.post<BaseExamination[]>(
            this.getServerRoot() + '/Visit/GetReportExaminations', { idReport }, this.buildOptions()
        );
    }

    buildColumns(): ColDef[] {
        return [
            {
                colId: '0',
                headerName: this.translate.instant('ExamDate'),
                headerTooltip: this.translate.instant('ExamDate'),
                tooltipField: 'examinationDate',
                field: 'examinationDate',
                width: 150,
                minWidth: 120,
                valueFormatter: this.gridUtils.dateFormatter('examinationDate'),
                comparator: this.gridUtils.dateComparator,
            },
            {
                colId: '1',
                headerName: this.translate.instant('Exam'),
                headerTooltip: this.translate.instant('Exam'),
                tooltipField: 'exam.description',
                field: 'exam.description',
                width: 420,
                minWidth: 190
            },
            {
                colId: '2',
                headerName: this.translate.instant('BusinessUnit'),
                headerTooltip: this.translate.instant('BusinessUnit'),
                tooltipField: 'businessUnit.description',
                field: 'businessUnit.description',
                width: 220,
                minWidth: 190
            }
        ];
    }
}
